import React, { useState } from "react";
import { useLocation } from "react-router-dom";

import DataService from "../../utils/dataservice";

import GenericChart from "../../common/custom-generic-chart/custom-generic-chart.js";
import "./question-based-graph.css";
import MarkdownRenderer from "react-markdown-renderer";

import Accordion from "react-bootstrap/Accordion";

const QuestionBasedGraph = () => {
  const [query, setQuery] = useState("");

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  console.log(queryParams.get("queryFlag")); // Check the value here
  const queryFlag = queryParams.get("queryFlag");

  const [loadRecomendations, setLoadRecomendations] = useState(false);
  // const [recomendationText, setRecomendationText] = useState("");
  const [loadingRec, setLoadingRec] = useState(true);
  // const [isEnabledShortAns, setIsEnabledShortAns] = useState(false);
  // const [isLoadingShortAns, setIsLoadingShortAns] = useState(false);
  // const [shortAns, setShortAns] = useState("");
  const [staticData, setStaticData] = useState([
    {
      isSelected: false,
      question:
        "Give me OMC wise count of CustomerIDs whose average month on month growth of Quantity during April to June is more than 10%",
      chartName: "OMC wise count",
      yAxis: [
        {
          data: [23617, 14578, 14410],
          lineLabel: "Customer ID's",
          type: "pie",
        },
      ],
      xAxis: [
        {
          data: ["MUWE", "VUEQ", "XUKA"],
          scaleType: "band",
          lineLabel: "OMC",
        },
      ],
    },
    {
      isSelected: false,
      question:
        "Give me Class of Mkt wise average month on month growth of Quantity from April to June in product GAJ",
      chartName: "Market Growth",
      yAxis: [
        {
          data: [-1.62, 2.1, 0.49, 0.54, 1.74, 0.41],
          lineLabel: "Avg Growth in %",
          type: "bar",
        },
      ],
      xAxis: [
        {
          data: [
            "H (Highway)",
            "L (Local)",
            "M4 (Metro)",
            "N8 (Non-Metro)",
            "T (Town)",
            "Y (City)",
          ],
          scaleType: "band",
          lineLabel: "Market",
        },
      ],
    },
    {
      isSelected: false,
      question:
        "Give me RO type wise average market share change for OMC MUWE during April to June for Product SH",
      chartName: "RO Report",
      yAxis: [
        {
          // negative value not able to plot the chart
          data: [-1.71, -1.87, -4.31],
          lineLabel: "Quantity",
          type: "bar",
        },
      ],
      xAxis: [
        {
          data: ["FLXR", "OFXW", "WMRQ"],
          scaleType: "band",
          lineLabel: "RO",
        },
      ],
    },
    {
      isSelected: false,
      question:
        "Give me the list of top 10 districts basis the average month on Month increase from April to June",
      chartName: "District Data",
      yAxis: [
        {
          data: [
            6796.855, 3904.5, 3852.5, 3572.905, 3510.845, 3221.5, 2941.955,
            2936.64, 2873.075, 2866.285,
          ],
          lineLabel: "Avg Increase",
          type: "bar",
        },
      ],
      xAxis: [
        {
          data: [
            "KA-BANGALORE-URB",
            "GJ-BANASKAHTHA",
            "-",
            "HR-GURGAON",
            "GJ-AHMEDABAD",
            "UT-DEHRADUN",
            "GJ-KUTCH",
            "TG-RANGA REDDY",
            "MH-PUNE (POONA)",
            "TN-MADRAS",
          ],
          scaleType: "band",
          lineLabel: "District",
        },
      ],
    },
    {
      isSelected: false,
      question:
        "Give me the list of Regional Office where OMC VUEQ has increased market share from April to May",
      chartName: "Regional Offices",
      yAxis: [
        {
          data: [
            0.210439, 0.203348, 0.185214, 0.1802, 0.178778, 0.166221, 0.154719,
            0.122383, 0.119161, 0.11106,
          ],
          lineLabel: "Avg Increase",
          type: "pie",
        },
      ],
      xAxis: [
        {
          data: [
            "Bengaluru",
            "Jammu",
            "Ahmedabad",
            "Rajkot",
            "Aurangabad",
            "Warangal",
            "Raipur",
            "Sholapur",
            "Baroda",
            "Kadapa",
          ],
          scaleType: "band",
          lineLabel: "District",
        },
      ],
    },
  ]);

  const [isEnabledChartData, setIsEnabledChartData] = useState(false);
  const [customQueryChartData, setCustomQueryChartData] = useState(null);
  const [isLoadingChartData, setIsLoadingChartData] = useState(false);

  const [insightsText, setInsightsText] = useState("");
  const [isLoadingInsightsText, setIsLoadingInsightsText] = useState(false);

  const [showChartDetails, setShowChartDetails] = useState(false);
  const [shortInsight, setShortInsight] = useState("");
  const [longInsight, setLongInsight] = useState("");
  const [showMoreDetails, setShowMoreDetails] = useState(false);

  const handleOnQuestionSelect = (data) => {
    setIsEnabledChartData(false);
    setLoadRecomendations(false);
    const updatedStaticData = staticData.map((ele) => {
      if (data.question === ele.question) {
        return { ...ele, isSelected: !ele.isSelected };
      }
      return { ...ele, isSelected: false };
    });

    const selectedQuestion = updatedStaticData.find((ele) => ele.isSelected);
    if (selectedQuestion) {
      setQuery(selectedQuestion.question);
      handleOnSubmitQuery(selectedQuestion.question);
    }

    setStaticData(updatedStaticData);
  };

  const handleOnQueryChange = (e) => {
    setQuery(e.target.value);
  };

  const handleOnReset = () => {
    setQuery("");
    const updatedStaticData = staticData.map((ele) => {
      return { ...ele, isSelected: false };
    });
    setStaticData(updatedStaticData);
  };

  const handleOnSubmitQuery = (query) => {
    if (query) {
      setCustomQueryChartData(null);
      setInsightsText("");
      setShortInsight("");
      setLongInsight("");
      setIsEnabledChartData(true);
      setIsLoadingChartData(true);

      setIsLoadingInsightsText(true);
      setLoadRecomendations(true);
      setLoadingRec(true);
      setShowChartDetails(true);
    }
  };

  const clearLoaderAndAPIcallFlags = () => {
    setIsEnabledChartData(false);
    setIsLoadingChartData(false);

    setIsLoadingInsightsText(false);
  };

  return (
    <>
      {/* load only Insight on submit query  */}
      {/* <DataService
        url={`https://ai-workbench.aisf.t-systems.net/api/insights_from_DB/v1/insights`}
        method="POST"
        data={{
          query: query,
        }}
        isEnabled={false}
        onSuccess={(data) => {
          setInsightsText(data.insights);
          setIsEnabledInsightData(false);
          setIsLoadingInsightsText(false);
        }}
        onError={() => {
          setIsEnabledInsightData(false);
          setIsLoadingInsightsText(false);
        }}
      /> */}

      {/* load only chart Data on submit query  */}
      <DataService
        url={
          "https://ai-workbench.aisf.t-systems.net/api/insights_from_DB/v1/query_and_insights"
        }
        method="POST"
        data={{
          query: query,
        }}
        isEnabled={isEnabledChartData}
        onSuccess={(data) => {
          if (typeof data.query_response === "string") {
            let insightTextData = data.query_response.split(`"data\"`);
            let finalInsighToShow = "";
            if (insightTextData[0]) {
              finalInsighToShow = insightTextData[0].split(`"Insight":`)[1];
            } else {
              finalInsighToShow = insightTextData.join("");
            }

            setCustomQueryChartData(null);
            setInsightsText(finalInsighToShow);
            clearLoaderAndAPIcallFlags();
          } else {
            setInsightsText(data.query_response[0].Insight);
            setCustomQueryChartData(data.query_response[0].data);
            clearLoaderAndAPIcallFlags();
          }
        }}
        onError={() => {
          setInsightsText("");
          setCustomQueryChartData(null);
          setIsLoadingChartData(false);
          clearLoaderAndAPIcallFlags();
        }}
      />
      {/* load only for short recommendation */}
      {/* <DataService
        url={`https://ai-workbench.aisf.t-systems.net/api/insights_from_DB/v1/recommendations_short`}
        method="POST"
        data={{
          query: query,
        }}
        isEnabled={isEnabledShortAns}
        onSuccess={(data) => {
          setShortAns(data.detail);
          setIsEnabledShortAns(false);
          setIsLoadingShortAns(false);
        }}
        onError={() => {
          setIsEnabledShortAns(false);
          setIsLoadingShortAns(false);
        }}
      /> */}

      <DataService
        url={
          "https://ai-workbench.aisf.t-systems.net/api/insights_from_DB/v1/recommendations_lengthy"
        }
        method="POST"
        data={{
          query: query,
        }}
        isEnabled={loadRecomendations}
        onSuccess={(data) => {
          if (data.detail && data.detail.length) {
            const [short] = data.detail.split("4.");
            setShortInsight(short);
            setLongInsight(data.detail);
          }

          setLoadRecomendations(false);
          setLoadingRec(false);
        }}
        onError={() => {
          setLoadRecomendations(false);
          setLoadingRec(false);
        }}
      />

      <div className="dashbord-container w-100 p-3">
        <div className="dashbord-page-content w-100">
          <div className="dash-heading">
            Ask something to get real time results{" "}
          </div>
          <div className="ask-question w-100">
            <input
              type="text"
              value={query}
              placeholder="Type here ..."
              className="queryInputBox"
              onChange={handleOnQueryChange}
            ></input>
          </div>

          <button
            type="btn"
            className="generate-btn mt-3"
            onClick={handleOnSubmitQuery}
          >
            Generate
          </button>

          <button
            type="btn"
            className="generate-btn mt-3 ms-2"
            onClick={handleOnReset}
          >
            Discard
          </button>
        </div>

        {staticData.length > 0 && queryFlag !== "true" ? (
          <>
            <div className="m-3 p-2 questions-container-div">
              {staticData.map((data, index) => (
                <div key={index} className="mb-2 position-relative">
                  <input
                    type="checkbox"
                    className="input-assumpte"
                    id={data.question}
                    checked={data.isSelected}
                    onChange={() => handleOnQuestionSelect(data)}
                    style={{ display: "none" }}
                  />
                  <label className="ms-4" for={data.question}>
                    {data.question}
                  </label>
                </div>
              ))}
            </div>
          </>
        ) : null}

        <div className="p-3 dashbord-page-top-cards d-flex">
          {/* {staticData.length > 0 &&
            staticData.map((chart, index) => (
              <>
                {chart.isSelected ? (
                  <>
                    {" "}
                    <div
                      key={index}
                      className="mb-2 position-relative mb-2 position-relative chartsBox"
                    >
                      {" "}
                      <div
                        className="chart-heading"
                        style={{ color: "#003078" }}
                      >
                        {chart.chartName}
                      </div>
                      {chart.yAxis[0] &&
                      chart.yAxis[0].type.toLowerCase() === "pie" ? (
                        <div className="pie-chart-legends" style={{}}>
                          {chart.xAxis[0].data.map((legend, index) => (
                            <div>
                              <div className="d-flex ">
                                <div
                                  className="legend-icon"
                                  style={{
                                    height: "20px",
                                    width: "20px",
                                    marginRight: "10px",
                                    backgroundColor: colorsList[index],
                                  }}
                                ></div>
                                <div className="legen-label">{legend}</div>
                              </div>
                            </div>
                          ))}
                        </div>
                      ) : null}
                      <GenericChart chartData={chart} />
                    </div>
                  </>
                ) : null}
              </>
            ))} */}
          <br></br>
          <div className="w-100"></div>

          <div className="d-flex w-100">
            {showChartDetails ? (
              <>
                {" "}
                <div className="mb-2 position-relative mb-2 position-relative chartsBox">
                  <>
                    {isLoadingChartData ? (
                      <div className="dash-heading">
                        Loading Chart Representation...
                      </div>
                    ) : (
                      <>
                        {customQueryChartData ? (
                          <GenericChart chartData={customQueryChartData} />
                        ) : (
                          <div className="dash-heading">
                            No Chart Suggessted
                          </div>
                        )}
                      </>
                    )}
                  </>
                </div>
                <div className="insights-container">
                  <Accordion defaultActiveKey="0">
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>Insights :</Accordion.Header>
                      <Accordion.Body>
                        {isLoadingInsightsText ? (
                          <div className="dash-heading">
                            Loading Insights...{" "}
                          </div>
                        ) : (
                          <MarkdownRenderer markdown={insightsText} />
                        )}
                      </Accordion.Body>
                    </Accordion.Item>
                    {/* <Accordion.Item eventKey="1">
                      <Accordion.Header
                        onClick={() => {
                          setIsEnabledShortAns(true);
                          setIsLoadingShortAns(true);
                        }}
                      >
                        Recommendation and action plan(Brief) :
                      </Accordion.Header>
                      <Accordion.Body>
                        {isLoadingShortAns ? (
                          <div className="dash-heading">
                            Recommendation and action plan....
                          </div>
                        ) : (
                          <MarkdownRenderer markdown={shortAns} />
                        )}
                      </Accordion.Body>
                    </Accordion.Item> */}
                    <Accordion.Item eventKey="2">
                      <Accordion.Header
                        onClick={() => {
                          if (
                            (!shortInsight || !longInsight) &&
                            !loadRecomendations
                          ) {
                            setLoadRecomendations(true);
                          }
                        }}
                      >
                        Recommendation and action plan :
                      </Accordion.Header>
                      <Accordion.Body>
                        {loadingRec ? (
                          <div className="dash-heading">
                            Loading Recommendations....
                          </div>
                        ) : (
                          <>
                            <div className="w-100 float-start mb-3 mt-2">
                              {" "}
                              <button
                                type="btn"
                                className="generate-btn mt-3 float-end"
                                onClick={() => {
                                  setShowMoreDetails(!showMoreDetails);
                                }}
                              >
                                {!showMoreDetails ? "Show More" : "Show Less"}
                              </button>
                            </div>
                            <div className="w-100">
                              <MarkdownRenderer
                                markdown={
                                  !showMoreDetails ? shortInsight : longInsight
                                }
                              />
                            </div>
                          </>
                        )}
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
              </>
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
};

export default QuestionBasedGraph;
